<template>
  <modal
    :title="setModel != undefined ? 'Update PaximumApı' : 'Add PaximumApı'"
    @close="$emit('close')"
  >
    <template #content>
      <Form
        method="dialog"
        @submit="onSubmit"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
      >
        <formGroup
          :title="'HotelName'"
          v-model="model.HotelName"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'PaximumId'"
          type="number"
          v-model.number="model.PaximumId"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'Username'"
          v-model="model.Username"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'Password'"
          v-model="model.Password"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'APIKey'"
          v-model="model.APIKey"
          :errors="errors"
          @keydown.enter="save"
        ></formGroup>
        <formGroup
          :title="'Active'"
          as="checkbox"
          v-model="model.Active"
          @keydown.enter="save"
        ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process">{{
        setModel != undefined ? "Update PaxımumAPI" : "Add PaxımumAPI"
      }}</Btn>
    </template>
  </modal>
</template>

<script>
export default {
  props: {
    setModel: Object,
    addId: Number,
  },
  data() {
    return {
      model: {
        Id: null,
        CustomerProviderId: this.addId,
        PaximumId: null,
        HotelName: "",
        Username: "",
        Password: "",
        APIKey: null,
        Active: true,
      },
      errs: {},
      process: false,
    };
  },
  created() {
    if (this.setModel != undefined) {
      this.model = { ...this.setModel };
    }
  },
  methods: {
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          this.$appAxiosAdmin
            .post(`KOLAYREZ/PaximumAPIS`, this.model)
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                text:
                  this.setModel != undefined
                    ? "The paximum api has been successfully updated."
                    : "The paximum api has been successfully added.",
                timer: 2000,
                confirmButtonText: "Okey",
              });
              if (this.setModel != undefined) {
                this.$emit("update", response.data);
              } else {
                this.$emit("add", response.data);
              }
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
